import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { LanguageService } from '../../../../../core/services/language.service';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ToastNotifService } from '../../../../../core/services/toastNotif.service';
import { ToastCustomService } from '../../../../../tools/services/toast/toast-custom/toastCustom.service';
import { CookieService } from 'ngx-cookie-service';
import { ApiReportService } from '../../../../../core/services/api/Report/api-report';
import { PssLoadingComponent } from "../../../../../tools/template/pss/pss-loading/pss-loading.component";
import { ReportPayload } from '../../../../../core/models/report/report.model';


@Component({
  imports: [CommonModule, FormsModule, PssLoadingComponent],
  templateUrl: './report-other.component.html',
  styleUrl: './report-other.component.css'
})
export class ReportOtherComponent implements OnInit {
  /* ------- Value ------- */
  currentLang: 'TH' | 'EN' = 'TH';
  uid: string = '';
  token: string = '';
  isLoading: boolean = false;

  // สำหรับหน้าแจ้งแอปพลิเคชัน ปรับหมวดหมู่ให้เหมาะสม
  categories: { value: number; label: string }[] = [
    { value: 5, label: 'ปัญหาการใช้งานแอปพลิเคชัน' }
  ];
  selectedCategory: { value: number; label: string } = { value: 5, label: 'ปัญหาการใช้งานแอปพลิเคชัน' };

  // Input
  detail: string = '';
  phone: string = '';

  // Image
  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;
  previewUrls: string[] = []; // รูปฐาน64
  currentIndex: number = 0;

  /* ------- Style ------- */
  showDropdown: boolean = false;

  constructor(
    private languageService: LanguageService,
    private router: Router,
    private toast: ToastNotifService,
    private toastCustomService: ToastCustomService,
    private cookieService: CookieService,
    private apiReportService: ApiReportService
  ) { }

  ngOnInit() {
    this.languageService.currentLang$.subscribe((lang) => {
      this.currentLang = lang;
    });

    // ดึงค่า UID ของ LINE จาก Cookie หรือ LocalStorage
    this.uid = this.cookieService.get('line_uid') || localStorage.getItem('line_uid') || '';
    this.token = '';
  }

  /*#################################################### Function ################################################*/

  showWarning(text: string) {
    this.toastCustomService.showWarning('', text);
  }

  showError(text: string) {
    this.toastCustomService.showError('', text);
  }

  showSuccess(text: string) {
    this.toastCustomService.showSuccess('', text);
  }

  triggerFileInput() {
    this.fileInput.nativeElement.click();
  }

  onSelectCategory(category: { value: number; label: string }) {
    this.selectedCategory = category;
    this.showDropdown = false;
  }

  handleFileChange(event: Event) {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];

    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        this.previewUrls.push(reader.result as string);
        if (this.previewUrls.length === 1) {
          this.currentIndex = 0;
        }
      };
      reader.readAsDataURL(file);
    }
  }

  prevImage() {
    if (this.previewUrls.length > 0) {
      this.currentIndex = (this.currentIndex - 1 + this.previewUrls.length) % this.previewUrls.length;
    }
  }

  nextImage() {
    if (this.previewUrls.length > 0) {
      this.currentIndex = (this.currentIndex + 1) % this.previewUrls.length;
    }
  }

  backToReport() {
    this.router.navigate(['/report-main']);
  }

  /*############################################# API #################################################*/

  // ส่งรายงานปัญหาเข้าสู่ระบบหลังบ้าน
  sendReport() {
    if (!this.detail || this.detail.trim() === '') {
      this.showError(this.currentLang === 'TH' ? 'กรุณากรอกรายละเอียดของปัญหา' : 'Please specify the issue details');
      return;
    }

    const payload: ReportPayload = {
      detail: this.detail.trim()
    };

    this.isLoading = true;

    this.apiReportService.sendReport(this.uid, this.token, payload).subscribe({
      next: (res) => {
        this.isLoading = false;
        this.showSuccess(this.currentLang === 'TH' ? 'ส่งรายงานปัญหาเรียบร้อยแล้ว' : 'Report submitted successfully');
        setTimeout(() => {
          this.router.navigate(['/report-main']);
        }, 1500);
      },
      error: (err) => {
        this.isLoading = false;
        this.showError(this.currentLang === 'TH' ? 'เกิดข้อผิดพลาดในการส่งข้อมูล' : 'Failed to submit report');
        console.error('Report submission error:', err);
      }
    });
  }
}
